import React, {useEffect, useState} from 'react';
import {Badge, Switch, Table} from "antd";
import {useProjectScope} from "./ProjectScopeProvider";
import {useProject} from "../../../providers/ClientProjectProvider";
import {CheckOutlined, CloseOutlined,} from "@ant-design/icons";
import DeliverableActivitiesTable from "./DeliverableActivitiesTable";

const PhaseDeliverableTable = ({record, canCustomize = true, expanded,...props}) => {

    const {
        getRecordKey,
        isEditing,
        editScopeRecord,
        onChange,
        cancelEdit,
        saveDataUpdate,
        editingKey,
        setEditingKey,
        editingType
    } = useProjectScope();

    const {project} = useProject();
    const [expandedKeys, setExpandedKeys] = useState([]);
    useEffect(() => {
        if (expanded && expandedKeys?.length) {
            setExpandedKeys([])
        }
    }, [expanded]);


    return (
        <div className="scope-inner-table">
            <div>
                <Table
                    rowKey="display_index"
                    expandable={{
                        expandedRowRender: (deliverable, index, indent, expanded) => (
                            <DeliverableActivitiesTable canCustomize={canCustomize} record={deliverable} expanded={expanded}/>
                        ),
                        expandedRowKeys: expandedKeys,
                        onExpandedRowsChange: (keys) => {
                            let newKeys = TB.difference(keys || [], expandedKeys || []);
                            newKeys = TB.filter(newKeys, key => !TB.isNaN(parseInt(key)))
                            return setExpandedKeys(newKeys)
                        }
                    }}
                    dataSource={record.deliverables}
                    bordered
                    size="middle"
                    pagination={false}>

                    <Table.Column
                        title="Deliverables"
                        dataIndex="name"
                        fixed="left"
                        width={150}
                        render={name => (
                            <p className="text-xs">{name}</p>
                        )}
                    />
                    <Table.Column
                        title="Assumptions"
                        dataIndex="assumptions"
                        width={260}
                        render={assumptions => (
                            <div className="relative">
                                <div
                                    dangerouslySetInnerHTML={{__html: assumptions || '<i>No Assumptions Provided</i>'}}
                                    className="text-xs line-clamp-3 overflow-ellipsis"/>
                            </div>
                        )}
                    />
                    <Table.Column
                        title="Client Feedback"
                        dataIndex="is_desired"
                        width={260}
                        render={(_, deliverable) => {
                            let color;

                            let label;
                            switch (deliverable.is_desired) {
                                case true:
                                    color = TB.config('color.success-dark');
                                    label = 'Yes';
                                    break;
                                case false:
                                    color = TB.config('color.danger-dark');
                                    label = 'No';
                                    break;
                                case null:
                                    color = '#b7b7b7';
                                    label = 'Unsure';
                                    break;
                            }
                            if (deliverable.is_custom) {
                                color = TB.config('color.warning-dark');
                                label = 'Custom';
                            }


                            return (
                                <div className="flex flex-col gap-4">
                                    <div className="flex flex-row items-center gap-2">
                                        <p className="text-xs font-semibold underline">
                                            Desired?
                                        </p>
                                        <Badge count={label} showZero color={color}/>
                                    </div>
                                    <div className="w-full flex flex-col items-start relative">
                                        <div className="relative">
                                            <p className="text-xs line-clamp-3 overflow-ellipsis">{deliverable.client_comments || (
                                                <i>No Addition Notes Provided</i>)}</p>
                                        </div>
                                    </div>
                                </div>
                            )
                        }}
                    />
                    <Table.Column
                        title="Talent Notes"
                        dataIndex="notes_to_talent"
                        width={260}
                        render={notes_to_talent => (
                            <div className="relative">
                                <p className="text-xs line-clamp-3 overflow-ellipsis"
                                   dangerouslySetInnerHTML={{__html: (notes_to_talent || '<i>No Notes Given</i>')}}/>
                            </div>
                        )}
                    />
                    <Table.Column
                        title="Hours"
                        dataIndex="total_hours"
                        width={40}
                        render={(_, deliverable) => (
                            <p className={TB.mapClass("text-xs", {"line-through opacity-60 text-danger": !deliverable.is_active})}>
                                {deliverable.total_hours}
                            </p>
                        )}
                    />
                    <Table.Column
                        title="Est Cost"
                        dataIndex="estimated_cost"
                        width={75}
                        render={(_, deliverable) => (
                            <p className={TB.mapClass("text-xs", {"line-through opacity-60 text-danger": !deliverable.is_active})}>
                                {TB.formatCurrency(deliverable.estimated_cost)}
                            </p>
                        )}
                    />
                    <Table.Column
                        title="Active?"
                        dataIndex="is_active"
                        width={40}
                        render={(_, deliverable) => (
                            <div>
                                <Switch
                                    size="small"
                                    checkedChildren={<CheckOutlined/>}
                                    unCheckedChildren={<CloseOutlined/>}
                                    checked={deliverable.is_active}
                                    onChange={async (checked) => {
                                        await onChange({[`${getRecordKey(deliverable)}.is_active`]: checked})
                                        return saveDataUpdate();
                                    }}
                                />
                            </div>
                        )}
                    />
                    <Table.Column
                        title="Actions"
                        dataIndex="operation"
                        width={100}
                        render={(_, deliverable) => (
                            <button className="btn btn-link btn-link-primary" disabled={!!editingKey}
                                    onClick={() => editScopeRecord(deliverable)}>
                                Edit
                            </button>
                        )}
                    />
                </Table>


                {canCustomize && (
                    <button className="btn btn-link btn-link-danger" disabled={!!editingKey} onClick={async (event) => {
                        let fieldName = `${getRecordKey(record)}.deliverables`;
                        let deliverables = [...record.deliverables, {
                            name: 'New Phase Deliverable',
                            is_active: false,
                            is_custom: true,
                            is_desired: null,
                            activities: [
                                {description: 'Activity for New Phase Deliverable', disciplines: []}
                            ]
                        }]

                        let newScope = await onChange({[fieldName]: deliverables});

                        let editingDeliverable = TB.last(TB.get(newScope, fieldName) || []);

                        await editScopeRecord(editingDeliverable);
                        setExpandedKeys([editingDeliverable.display_index]);

                    }}>
                        Add new deliverable
                    </button>
                )}

            </div>
        </div>
    );
};

export default PhaseDeliverableTable;